module.exports = __webpack_public_path__ + "static/media/seal.094bf02c.svg";